import React from 'react'
import DashboardComponents from '../dashboardComponents'

const ResultsDashboardComponentsUniCourse = ({
  results,
  preAnalyticData,
  courses
}) => {
  const courseId = results && results.courseId
  const filterSurveyCourseId = courses.find(
    course => course.id === parseInt(courseId, 10)
  )
  const name = filterSurveyCourseId.name
  const filterPreAnalyticData = preAnalyticData.find(
    data => data.courseId === courseId
  )
  return (
    <DashboardComponents
      name={name}
      filterPreAnalyticData={filterPreAnalyticData}
      results={results}
    />
  )
}

export default ResultsDashboardComponentsUniCourse
